module.exports = __webpack_public_path__ + "static/media/logo.39e26e33.png";